<template>
<div class="chapter">
<div class="inner_page">
<p class="C137"><a id="page_xv">A GREAT SACRIFICE</a></p><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Halftitle_Page_1.vue?49122811